/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_BiographyInputs */

const en_onboarding_genre_biography = /** @type {(inputs: Onboarding_Genre_BiographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biography`)
};

const es_onboarding_genre_biography = /** @type {(inputs: Onboarding_Genre_BiographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biografía`)
};

/**
* | output |
* | --- |
* | "Biography" |
*
* @param {Onboarding_Genre_BiographyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_biography = /** @type {((inputs?: Onboarding_Genre_BiographyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_BiographyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_biography(inputs)
	return en_onboarding_genre_biography(inputs)
});